import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AdalService } from '../adal/adal.service';
import { AppSettingsService } from './appsettings.service';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

//router: Router
    constructor(
        private authService: AdalService,
        private appSettingsService: AppSettingsService,
        private adalService: AdalService,
        private router: Router
    )

    {
    //this.router = router;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (this.authService.userInfo.isAuthenticated) { 
            var resource = this.adalService.GetResourceForEndpoint(this.router.url);
            var token = this.adalService.getCachedToken(resource);
            return new Promise((res) => { res(); }).then(() => { return true; });
        }

        return this.appSettingsService.getAppSettings()
            .then(() => {
                this.appSettingsService.setRedirectPath(window.location.pathname);
                this.adalService.init(this.appSettingsService.adalConfig);
                this.adalService.handleWindowCallback();
                //if (this.adalService.userInfo.isAuthenticated) {

                //    this.router.navigate([this.appSettingsService.adalConfig.redirectPath]);
                //}
                //else {
                //    this.adalService.clearCache();
                //    this.adalService.login();
                //}
                return true;
            });


        //if (!this.authService.userInfo.isAuthenticated)
        //{

        //    var path = state.url;
        //    this.appSettingsService.setRedirectPath(path);
        //    this.appSettingsService.setRedirectUri(window.location.origin + path);
        //    this.authService.init(this.appSettingsService.adalConfig);
        //    this.authService.handleWindowCallback();
        //    this.authService.login();
        //    return false;
        //}
        //return this.authService.userInfo.isAuthenticated;
        //return true;
    }
}


// WEBPACK FOOTER //
// ./app/services/authguard.service.ts